<template>
  <li v-if="liveEvents.length">
    <details class="group [&_summary::-webkit-details-marker]:hidden" :open="isLiveRouteActive">
      <summary
        class="flex cursor-pointer items-center justify-between rounded-lg px-4 py-2 text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-gray-700 dark:hover:text-gray-200"
      >
        <span class="flex items-center gap-2 text-sm font-medium">
          <i class="pi pi-fw pi-circle-fill layout-menuitem-icon live-menu-icon"></i>
          <span class="layout-menuitem-text">Live</span>
        </span>

        <span class="shrink-0 transition duration-300 group-open:rotate-180">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="size-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
              clip-rule="evenodd"
            ></path>
          </svg>
        </span>
      </summary>

      <ul class="mt-2 space-y-1 px-4">
        <li v-for="event in liveEvents" :key="event.id">
          <router-link
            :to="`/events/live/${event.id}`"
            :class="[
              'flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-medium transition-colors',
              isEventActive(event.id)
                ? 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-200'
                : 'text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-gray-700 dark:hover:text-gray-200'
            ]"
            @click="handleLinkClick"
          >
            <i class="pi pi-fw pi-circle-fill layout-menuitem-icon live-menu-icon"></i>
            <span class="layout-menuitem-text min-w-0 truncate">{{ event.name }}</span>
            <span
              v-if="event.activeOverlayTemplateId"
              class="ml-auto inline-flex shrink-0 items-center gap-1 rounded-full bg-amber-100 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-amber-900 dark:bg-amber-900/60 dark:text-amber-100"
              data-testid="live-nav-overlay-active"
              title="Overlay is showing on phones"
            >
              <i class="pi pi-eye text-[9px]" aria-hidden="true"></i>
              Overlay
            </span>
          </router-link>
        </li>
      </ul>
    </details>
  </li>
</template>

<script>
import { computed } from "vue";
import { useRoute } from "vue-router";

export default {
  name: "LiveNavSection",
  props: {
    liveEvents: {
      type: Array,
      default: () => []
    }
  },
  emits: ["link-click"],
  setup(props, { emit }) {
    const route = useRoute();

    const isLiveRouteActive = computed(() => route.path.startsWith("/events/live"));

    const isEventActive = (eventId) => {
      return route.params.eventId === String(eventId);
    };

    const handleLinkClick = () => {
      emit("link-click");
    };

    return {
      isLiveRouteActive,
      isEventActive,
      handleLinkClick
    };
  }
};
</script>

<style scoped>
.live-menu-icon {
  color: #05c115;
  transition: color 0.15s ease-in-out;
}

summary:hover .live-menu-icon,
:deep(a:hover .live-menu-icon) {
  color: #13ae20;
}

:deep(a.bg-gray-100 .live-menu-icon) {
  color: #05ea18;
}

details[open] summary .live-menu-icon {
  color: #05ea18;
}
</style>
